import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Option } from '../../../shared/composants/form-utils/inputs/input-select/input-select.component';

@Pipe({
  name: 'translateJoin',
  standalone: true,
})
export class TranslateJoinPipe implements PipeTransform {
  private readonly transloco = inject(TranslocoService);

  /**
   * Gets the currently Selected Options of a multi-select input and joins them with a separator
   * this is used to display the current selection for the user
   * @param options the selected options of the select
   * @param separator the chosen separator ( default comma ', ')
   */
  transform(options: Option[], separator = ', '): string {
    return options
      .map((o) => (o.label ? this.transloco.translate(o.label) : o.value))
      .join(separator);
  }
}
